import { navLinks } from '@/mocks/content';

const keywordTags = [
  '星辰影院',
  '星辰影院最新电影',
  '星辰影院新片上映',
  '星辰影院院线同步',
  '星辰影院热播大片',
  '星辰影院2024新片',
  '星辰影院今日更新',
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 text-primary-900">
                <i className="ri-film-line text-xl" />
              </span>
              <span className="text-lg md:text-xl font-black tracking-wide">星辰影院</span>
            </div>
            <p className="mt-4 text-sm text-primary-100/80 leading-relaxed max-w-md">
              一页聚合最新电影、新片上映、院线同步与热播大片，并整理 2024 新片与今日更新，帮助你在最短时间内缩小查找范围、找到想看的影片。
            </p>
            <p className="mt-4 text-xs text-primary-100/60 leading-relaxed">
              本页内容为一般性信息整理，影片名称、评分与档期为演示用途，不构成对具体影片上架或放映时间的承诺。
            </p>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-sm font-bold tracking-wider text-background-50">页面分区</h3>
            <ul className="mt-4 grid grid-cols-2 gap-y-2.5 gap-x-4">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-primary-100/80 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-sm font-bold tracking-wider text-background-50">主题关键词</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {keywordTags.map((tag) => (
                <span key={tag} className="px-2.5 py-1 rounded-full bg-primary-800/70 text-primary-100/85 text-xs">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-700/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-100/60">© 2024 星辰影院 · 中文电影资讯单页站</p>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 text-xs text-primary-100/80 hover:text-accent-300 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-up-line" />
            回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}